<script>
import { authMethods } from '@/state/helpers'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { userService } from '@/helpers/fakebackend/user.service'
import CountDownTimer from '../../../components/CountDownTimer'

export default {
  components: {
    CountDownTimer,
    FormWizard,
    TabContent,
  },
  data() {
    return {
      user: {
        mobile: '',
        token: '',
        email: '',
        username: '',
        password: '',
        password_confirmation: '',
        token_id: '',
      },
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
      currentStep: 0,
      timerEnded: true,
    }
  },
  created() {
    document.body.classList.add('auth-body-bg')
  },
  methods: {
    ...authMethods,
    // Try to register the user in with the email, username
    // and password they provided.

    async validateAsync() {
      const valid = await this.$refs[`step${this.currentStep}`].validate()
      return new Promise((resolve, reject) => {
        if (valid) {
          switch (this.currentStep) {
            case 0:
              this.timerEnded = true
              userService
                .requestToken(this.user.mobile, 'register')
                .then((res) => {
                  this.timerEnded = false
                  this.user.token = ''
                  this.user.token_id = res.data.token_id
                  this.currentStep = 1
                  resolve(true)
                })
                .catch(() => {
                  reject()
                })
              break
            case 1:
              userService
                .verifyToken(
                  {
                    mobile: this.user.mobile,
                    token: this.user.token,
                    token_id: this.user.token_id,
                  },
                  'register'
                )
                .then(() => {
                  resolve(true)
                })
                .catch(() => {
                  reject()
                })
              break
            case 2:
              resolve(true)
              break
          }
        } else {
          reject()
        }
      })
    },
    handleChangeStep(prevIndex, nextIndex) {
      this.currentStep = nextIndex
    },
    requestToken() {
      userService.requestToken(this.user.mobile, 'register').then((res) => {
        this.timerEnded = false
        this.user.token_id = res.data.token_id
      })
    },
    tryToRegister() {
      const data = JSON.parse(JSON.stringify(this.user))
      data.phoneno = data.mobile
      userService.register(data).then(() => {
        setTimeout(function() {
          window.location.href = '/'
        }, 1000)
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4 px-0">
            <div
              class="authentication-page-content p-4 d-flex align-items-center min-vh-100"
            >
              <div class="w-100">
                <div class="row px-0 justify-content-center">
                  <div class="col-lg-11">
                    <div>
                      <div class="text-center">
                          <div>
                          <a href="/" class="logo">
                            <img
                              src="@/assets/images/logo-light.png"
                              height="40"
                              alt="logo"
                            />
                          </a>
                        </div>


                        <h4 class="font-size-18 mt-4">ایجاد حساب کاربری</h4>
                        <p class="text-muted">
                          حساب خود را به رایگان ایجاد کنید
                        </p>
                      </div>
                      <div class="p-2 mt-5">
                    
                        <form-wizard
                          @on-complete="tryToRegister"
                          @on-change="handleChangeStep"
                          next-button-text="بعدی"
                          back-button-text="قبلی"
                          finish-button-text="ایجاد حساب کاربری"
                          shape="tab"
                          color="#556ee6"
                        >
                          <tab-content
                            :before-change="validateAsync"
                            title="تلفن همراه"
                          >
                            <ValidationObserver ref="step0" tag="div">
                              <form @submit.prevent class="needs-validation">
                                <div class="row px-0">
                                  <div class="col-12 px-0">
                                    <div>
                                      <div>
                                        <h6>
                                          برای شروع تلفن همراه خود را وارد کنید
                                        </h6>
                                        <div class="row">
                                          <div class="col-12">
                                            <validation-input
                                              v-model="user.mobile"
                                              type="text"
                                              placeholder="تلفن همراه"
                                              rules="required|max:15|mobile"
                                              validation-field-name="تلفن همراه"
                                              label="تلفن همراه"
                                            ></validation-input>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </ValidationObserver>
                          </tab-content>
                          <tab-content
                            :before-change="validateAsync"
                            title="احراز هویت"
                          >
                            <ValidationObserver ref="step1" tag="div">
                              <form @submit.prevent class="needs-validation">
                                <div class="row px-0">
                                  <div class="col-12 px-0">
                                    <div>
                                      <div>
                                        <div class="row">
                                          <div class="col-12">
                                            <h6>
                                              کد تأییدی که برای شما پیامک شده
                                              است را وارد کنید
                                            </h6>
                                          </div>
                                          <div class="col-12">
                                            <validation-input
                                              v-model="user.token"
                                              type="text"
                                              placeholder="کد تایید"
                                              rules="required"
                                              validation-field-name="کد تایید"
                                              label="کد تایید"
                                            ></validation-input>
                                            <span
                                              class=" mb-2"
                                              style="float: left;display: inline-block"
                                            >
                                              <count-down-timer
                                                v-if="!timerEnded"
                                                :start-timer="!timerEnded"
                                                :time="120"
                                                @end_call_back="
                                                  timerEnded = true
                                                "
                                              />
                                              <span
                                                @click="requestToken"
                                                style="cursor: pointer"
                                                class="text-primary"
                                                v-if="timerEnded"
                                                >درخواست مجدد</span
                                              >
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </ValidationObserver>
                          </tab-content>
                          <tab-content
                            :before-change="validateAsync"
                            title="ثبت رمز عبور"
                          >
                            <ValidationObserver ref="step2" tag="div">
                              <form @submit.prevent class="needs-validation">
                                <div class="row px-0">
                                  <div class="col-12 px-0">
                                    <div class="row">
                                      <div class="col-12">
                                        <validation-input
                                          label="نام کاربری"
                                          placeholder="نام کاربری"
                                          rules="required"
                                          validation-field-name="نام کاربری"
                                          v-model="user.username"
                                        >
                                        </validation-input>
                                      </div>
                                      <div class="col-12">
                                        <validation-input
                                          label="رمز عبور"
                                          placeholder="رمز عبور"
                                          rules="required|min:8"
                                          validation-field-name="رمز عبور"
                                          v-model="user.password"
                                          type="password"
                                          vid="password"
                                        >
                                        </validation-input>
                                      </div>
                                      <div class="col-12">
                                        <validation-input
                                          label="تکرار رمز عبور"
                                          placeholder="تکرار رمز عبور"
                                          rules="required|min:8|confirmed:password"
                                          validation-field-name="تکرار رمز عبور"
                                          v-model="user.password_confirmation"
                                          type="password"
                                        >
                                        </validation-input>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </ValidationObserver>
                          </tab-content>
                        </form-wizard>
                      </div>
                      <div class="mt-5 text-center">
                        <p>
                          حساب کاربری دارید؟
                          <router-link
                            tag="a"
                            to="/login"
                            class="font-weight-medium text-primary"
                            >ورود
                          </router-link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
